import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-incidents-add-hyperlink-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class IncidentsAddHyperlinkManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel> {
            name: this.translation.t("tableOfContents.addHyperlinkToIncident"),
            description: this.translation.t("specs.addHyperlinkToIncidentDescription"),
            httpMethod: "POST",
            path: "/api/incidents/{guid}/add/hyperlink",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.addHyperlinkToIncidentGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "name",
                    description: this.translation.t("parameters.incidentNameDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "hyperlink name",
                },
                {
                    name: "hyperlink",
                    description: this.translation.t("parameters.incidentHyperlinkDescription"),
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "https://www.example.com",
                },
                {
                    name: "description",
                    description: this.translation.t("parameters.incidentDescriptionDescription"),
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "hyperlink description",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                }
            ]
        }
    }
}